<template>
  <v-select
    hide-details
    class="ma-0 pa-0"
    label="Группа здоровья"
    prepend-icon="add_circle_outline"
    item-text="name"
    item-value="id"
    v-model="value"
    :items="items"
    :loading="loading"
    @change="save"
  ></v-select>
</template>

<script>
export default {
  name: "HealthGroup",

  data: () => ({
    loading: false,
    value: "",
    items: [],
  }),

  async created() {
    await this.loadData();
  },

  methods: {
    async loadData() {
      this.loading = true;

      try {
        const response = await this.$http.get(`v1/customers/${this.$store.state.customer.id}/health-group`, {
          params: { lang: "ru" },
        });

        if (response.data.success) {
          this.items = response.data.data.group;
          this.value = response.data.data.current ? response.data.data.current.group : "";
        }
      } catch (e) {
        console.error(e.response);
      }

      this.loading = false;
    },

    async save() {
      this.loading = true;

      try {
        const response = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/health-group`, {
          group: this.value,
        });

        if (response.data.success) {
          this.$notify.showMessage("Группа успешно сохранена", "success");
        }
      } catch (e) {
        this.$notify.showMessage(e.response.data.message || "Ошибка сохранения", "error");
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
